module.exports = __webpack_public_path__ + "static/media/lucky_logo2_pp.f0e698c4.png";